import React from 'react';
import { EditForm } from './components/EditForm';
import style from './Forms.module.scss';

export const Forms: React.FC = () => {
	return (
		<div className={style.container} data-test="Forms">
			<EditForm />
		</div>
	);
};
